import { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { setLocale } from "react-redux-i18n";

export default function SetLanguage(props) {
    const dispatch = useDispatch();
    useEffect(() => {
        if (props.match.params.lng) {
            dispatch(setLocale(props.match.params.lng));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}
